import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_procurement-central-1/artifacts/itphun63_FullLogo_NoBuffer%20%281%29.png";

export default function JoinTeam() {
  const { inviteCode } = useParams();
  const navigate = useNavigate();
  const { registerWithInvite } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    
    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      await registerWithInvite(inviteCode, formData.password);
      toast.success('Welcome to the team!');
      navigate('/');
    } catch (error) {
      console.error('Join error:', error);
      toast.error(error.response?.data?.detail || 'Invalid or expired invite');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="join-page">
      <Card className="w-full max-w-md border border-border shadow-none rounded-sm">
        <CardHeader className="text-center pb-2">
          <img src={LOGO_URL} alt="Solar Paradigm" className="h-12 mx-auto mb-4" />
          <CardTitle className="text-xl font-heading">Join Solar Paradigm</CardTitle>
          <CardDescription>Set a password to complete your account</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="rounded-sm mt-1.5"
                required
                data-testid="input-join-password"
              />
            </div>
            <div>
              <Label htmlFor="confirmPassword">Confirm Password</Label>
              <Input
                id="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                className="rounded-sm mt-1.5"
                required
                data-testid="input-join-confirm"
              />
            </div>
            <Button 
              type="submit" 
              className="w-full rounded-sm" 
              disabled={loading}
              data-testid="btn-join"
            >
              {loading ? 'Joining...' : 'Join Team'}
            </Button>
          </form>
          <p className="text-center text-sm text-muted-foreground mt-4">
            Already have an account?{' '}
            <Link to="/login" className="text-primary hover:underline">
              Sign in
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
